// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2KnB-","title":"InfoRow_title__FlyMp"};